import React from "react";
import styles from "./styles/Billing.module.css"


function TableFooter({filter, setFilter, maxPages, handleChange}) {

    return (
        <div className={styles.footer}>
            <input className={styles.log_input} onChange={(e)=>handleChange(e.target.value, "nlogs")} value={filter.nlogs}>
            </input>
            <button onClick={()=>handleChange(filter.page-1, "page")} className={styles.pagination} disabled={filter.page===1}>Previous</button>
            <div>Page {filter.page} of {maxPages}</div>
            <button onClick={()=>handleChange(filter.page+1, "page")} disabled={filter.page>=maxPages} className={styles.pagination}>Next</button>
        </div>
    );
}

export default TableFooter;
